<template>
  <div class="card">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="$t('success_msg_report')"
      :heading="$t('success_heading_report')"
    />
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <form class="form" @submit.prevent="submitForm">
            <!-- <div class="form-group">
              <label>Title</label>
              <input
                type="text"
                name="title"
                v-model="title"
                class="form-control"
                required
                placeholder="Enter a Report title"
              />
            </div> -->
            <div class="d-flex col-gap-1">
              <!-- <div class="form-group w-100">
                <label>Type</label>
                <select class="form-control" name="max-sms" v-model="type">
                  <option value="excursion">Excursion</option>
                  <option value="temperature/humidity"
                    >Temperature/Humidity</option
                  >
                  <option value="Location">Location</option>
                </select>
              </div> -->
              <div class="form-group w-100">
                <label for="title">{{ $t("title") }} </label>
                <input
                  type="text"
                  name="title"
                  v-model="title"
                  class="form-control"
                  required
                  placeholder=""
                  id="title"
                />
              </div>

              <div class="form-group w-100">
                <label for="timezone">{{ $t("timezones") }}</label>
                <select
                  required
                  class="form-control"
                  name="max-sms"
                  v-model="timezone"
                  id="timezone"
                >
                  <option
                    v-for="timezone in reportTimezones"
                    :key="timezone"
                    :value="timezone"
                  >
                    {{ timezone }}
                  </option>
                </select>
              </div>
            </div>

            <hr />

            <p>{{ $t("sch_auto") }}</p>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group w-100">
                  <label style="width: 7rem">{{ $t("period") }}</label>
                  <div class="w-100 d-flex">
                    <select
                      class="form-control"
                      name="max-sms"
                      v-model="period"
                      required
                    >
                      <option value="" selected>{{ $t("sel") }}</option>
                      <option value="weekly">{{ $t("weekly") }}</option>
                      <option value="daily">{{ $t("daily") }}</option>
                      <option value="monthly">{{ $t("monthly") }}</option>
                    </select>
                  </div>
                </div>
                <!-- Weekly -->
                <div v-if="period === 'weekly'">
                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("weekly") }} {{ $t("from") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <select
                        class="form-control"
                        v-model="weekly.fromDay"
                        required
                      >
                        <option value="" selected>{{ $t("sel") }}</option>
                        <option value="monday">{{ $t("mond") }}</option>
                        <option value="tuesday">{{ $t("tue") }}</option>
                        <option value="wednesday">{{ $t("wed") }}</option>
                        <option value="thursday">{{ $t("thur") }}</option>
                        <option value="friday">{{ $t("fri") }}</option>
                        <option value="saturday">{{ $t("sat") }}</option>
                        <option value="sunday">{{ $t("sun") }}</option>
                      </select>
                      <input
                        type="time"
                        class="form-control"
                        v-model="weekly.fromTime"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("weekly") }} {{ $t("to") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <select
                        class="form-control"
                        v-model="weekly.toDay"
                        required
                      >
                        <option value="" selected>{{ $t("sel") }}</option>
                        <option value="monday">{{ $t("mond") }}</option>
                        <option value="tuesday">{{ $t("tue") }}</option>
                        <option value="wednesday">{{ $t("wed") }}</option>
                        <option value="thursday">{{ $t("thur") }}</option>
                        <option value="friday">{{ $t("fri") }}</option>
                        <option value="saturday">{{ $t("sat") }}</option>
                        <option value="sunday">{{ $t("sun") }}</option>
                      </select>
                      <input
                        type="time"
                        class="form-control"
                        v-model="weekly.toTime"
                        required
                      />
                    </div>
                  </div>
                </div>

                <!-- Daily -->
                <div v-if="period === 'daily'">
                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("daily") }} {{ $t("from") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <input
                        type="time"
                        class="form-control"
                        v-model="daily.fromTime"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("daily") }} {{ $t("to") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <input
                        type="time"
                        class="form-control"
                        v-model="daily.toTime"
                        required
                      />
                    </div>
                  </div>
                </div>

                <!-- Monthly -->
                <div v-if="period === 'monthly'">
                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("monthly") }} {{ $t("from") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <select
                        class="form-control"
                        v-model="monthly.fromDay"
                        required
                      >
                        <option value="" selected>{{ $t("sel") }}</option>
                        <option
                          v-for="(date, i) in 31"
                          :key="i"
                          :value="date.toString()"
                        >
                          {{ date.toString() }}
                        </option>
                      </select>
                      <input
                        type="time"
                        class="form-control"
                        v-model="monthly.fromTime"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group w-100">
                    <label style="width: 7rem"
                      >{{ $t("monthly") }} {{ $t("to") }}</label
                    >
                    <div class="w-100 d-flex col-gap-1">
                      <select
                        class="form-control"
                        v-model="monthly.toDay"
                        required
                      >
                        <option value="" selected>{{ $t("sel") }}</option>
                        <option
                          v-for="(date, i) in 31"
                          :key="i"
                          :value="date.toString()"
                        >
                          {{ date.toString() }}
                        </option>
                      </select>
                      <input
                        type="time"
                        class="form-control"
                        v-model="monthly.toTime"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="active-select px-2" for="">{{
                    $t("devices")
                  }}</label>
                  <div
                    class="device-select mb-2"
                    v-click-outside="handleHideDevices"
                  >
                    <div class="position-relative">
                      <input
                        type="text"
                        v-model="key"
                        @input="doSearch($event)"
                        class="font-16 device-select"
                        :placeholder="$t('search_devices')"
                        style="height: 2.3rem; width: 100%; padding-left: 40px"
                        @focus="handleDeviceFocus"
                      />
                      <i
                        class="fas fa-search fa-lg position-absolute"
                        style="top: 12px; left: 10px; color: #b7c3cd"
                      ></i>
                    </div>
                    <!-- <div class="top-select d-flex">
                      <span
                        style="background: #BDBDBD; cursor:pointer"
                        @click="selectAll()"
                        >{{ $t("sel_all") }}</span
                      >
                      <span
                        style="background: #ECECEC;cursor:pointer"
                        @click="deSelectAll()"
                        >{{ $t("desel_all") }}</span
                      >
                      <i class="icon-search"></i>
                    </div> -->
                    <div
                      class="devices"
                      :style="devices.length > 2 && 'overflow-y:auto'"
                      v-show="showDevices"
                    >
                      <div v-if="filteredDevices.length > 0">
                        <div class="check-devices d-flex mb-2">
                          <input
                            type="checkbox"
                            :checked="isSelectAll"
                            name="selected-device"
                            @click="isSelectAll ? deSelectAll() : selectAll()"
                            id="check-all-device"
                          />
                          <label
                            for="check-all-device"
                            class="gray4 mb-0 font-16"
                            style="margin-left: 0.7rem; font-weight: 100"
                            >{{ $t("sel_all") }}</label
                          >
                        </div>
                        <div
                          class="check-devices d-flex mb-2"
                          v-for="(item, i) in filteredDevices"
                          :key="i"
                        >
                          <input
                            type="checkbox"
                            :checked="selectCheck(item.id)"
                            :id="item.id"
                            name="selected-device"
                            @click="onDeviceSelect(item.id)"
                            class="cursor-pointer"
                          />
                          <label
                            :for="item.id"
                            class="gray4 mb-0 font-16 cursor-pointer"
                            style="margin-left: 0.7rem; font-weight: 100"
                            >{{ item.settings.name }}</label
                          >
                        </div>
                      </div>
                      <div v-else>
                        <h4 class="text-center mb-0 gray4">
                          {{ $t("no_dev_found") }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="d-block col-gap-2 mt-5">
                  <div class="w-100">
                    <div class="check">
                      <label for="checkbox">{{ $t("add_emails") }} </label>
                    </div>

                    <div
                      @click="openDrop = !openDrop"
                      v-click-outside="closeDropdown"
                      class="w-100 outter"
                    >
                      <Dropdown
                        :checked="openDrop"
                        @open="opendrop"
                        :email="true"
                        :users="users"
                        :selectedEmailList="selectedEmailList"
                        @selected="selectedEmails"
                      />
                    </div>
                  </div>
                  <div
                    v-show="erroNotification !== ''"
                    class="alert-danger alert-dismissible fade show"
                  >
                    <p class="p-2">{{ erroNotification }}</p>
                  </div>
                </div> -->

                <div class="form-group w-100">
                  <label class="px-2" for="">{{ $t("users") }}</label>
                  <div
                    class="device-select mb-2"
                    v-click-outside="handleHideUsers"
                  >
                    <div class="position-relative">
                      <input
                        type="text"
                        v-model="usersKey"
                        @input="doSearchUsers($event)"
                        class="font-16 device-select"
                        :placeholder="$t('search_devices')"
                        style="height: 2.3rem; width: 100%; padding-left: 40px"
                        @focus="handleUserFocus"
                      />
                      <i
                        class="fas fa-search fa-lg position-absolute"
                        style="top: 12px; left: 10px; color: #b7c3cd"
                      ></i>
                    </div>
                    <!-- <div class="top-select d-flex">
                      <span
                        style="background: #BDBDBD; cursor:pointer"
                        @click="selectAll()"
                        >{{ $t("sel_all") }}</span
                      >
                      <span
                        style="background: #ECECEC;cursor:pointer"
                        @click="deSelectAll()"
                        >{{ $t("desel_all") }}</span
                      >
                      <i class="icon-search"></i>
                    </div> -->
                    <div
                      class="devices"
                      :style="users.length > 2 && 'overflow-y:auto'"
                      v-show="showUsers"
                    >
                      <div v-if="users.length > 0">
                        <div class="check-devices d-flex mb-2">
                          <input
                            type="checkbox"
                            :checked="isSelectAllUser"
                            name="selected-users"
                            @click="
                              isSelectAllUser
                                ? deSelectAllUsers()
                                : selectAllUsers()
                            "
                            id="select-all-users"
                            class="cursor-pointer"
                          />
                          <label
                            for="select-all-users"
                            class="gray4 mb-0 font-16 cursor-pointer"
                            style="margin-left: 0.7rem; font-weight: 100"
                            >{{ $t("sel_all") }}</label
                          >
                        </div>
                        <div
                          class="check-devices d-flex mb-2"
                          v-for="(item, i) in users"
                          :key="i"
                        >
                          <input
                            type="checkbox"
                            :checked="selectCheckUser(item.id)"
                            :id="item.id"
                            name="selected-device"
                            @click="onUserSelect(item.id)"
                            class="cursor-pointer"
                          />
                          <label
                            :for="item.id"
                            class="gray4 mb-0 font-16 cursor-pointer"
                            style="margin-left: 0.7rem; font-weight: 100"
                            >{{ item.fullname }}</label
                          >
                        </div>
                      </div>
                      <div v-else>
                        <h4 class="text-center mb-0 gray4">
                          {{ $t("no_dev_found") }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5 mt-3">
              <div class="form-group w-100 mb-0">
                <label class="px-2" for="">{{ $t("format") }}</label>
                <div class="format-options">
                  <div
                    class="check-devices d-flex mb-2"
                    v-for="(option, index) in formatOptions"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      :checked="format.includes(option.value)"
                      :id="`format-${option.value}`"
                      name="format-options"
                      @click="onFormatSelect(option.value)"
                      class="cursor-pointer"
                    />
                    <label
                      :for="`format-${option.value}`"
                      class="gray4 mb-0 font-16 cursor-pointer"
                      style="margin-left: 0.7rem; font-weight: 100"
                      >{{ option.label }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="d-flex col-gap-1 justify-content-end">
                <button type="button" class="btn btn-secondary" @click="cancel">
                  {{ $t("cancel") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="timezoneLoading"
                >
                  {{ btnText }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Dropdown from "../../components/Dropdown.vue";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import vClickOutside from "v-click-outside";
import SuccessModal from "../Modals/SuccessModal.vue";
export default {
  data() {
    return {
      smsInterval: null,
      maxSms: null,
      isLoading: false,
      fullPage: true,
      erroNotification: "",
      key: "",
      usersKey: "",
      filteredDevices: [],
      filteredUsers: [],
      showDevices: false,
      showUsers: false,

      period: "weekly",
      weekly: {
        fromDay: "",
        toDay: "",
        fromAmPm: "am",
        toAmPm: "am",
        fromTime: "",
        toTime: "",
      },
      daily: {
        fromAmPm: "am",
        toAmPm: "am",
        fromTime: "",
        toTime: "",
      },
      monthly: {
        fromDay: "",
        toDay: "",
        fromAmPm: "am",
        toAmPm: "am",
        fromTime: "",
        toTime: "",
      },
      openDrop: false,
      selectedEmailList: [],
      device: [],
      type: "",
      title: "",
      format: ["pdf"],
      formatOptions: [
        { label: "Export as PDF", value: "pdf" },
        { label: "Export as CSV", value: "csv" },
        { label: "Export as ASCII", value: "ascii" },
        { label: "Export as HTML", value: "html" },
        { label: "Export as JPEG", value: "jpeg" },
        { label: "Export as PDF-Log", value: "pdf-log" },
      ],
      btnText: this.$t("gen_"),
      showSuccessPopup: false,
      timezone: "",
    };
  },
  name: "CreateReport",
  props: {
    report: Object,
  },
  components: {
    // Dropdown,
    Loading,
    SuccessModal,
  },
  methods: {
    doSearch() {
      let newData = [];
      newData = this.devices.filter(
        (item) =>
          item.settings.name.toLowerCase().includes(this.key) ||
          item.settings.name.toUpperCase().includes(this.key) ||
          item.settings.name.includes(this.key)
      );
      this.filteredDevices = newData;
    },
    doSearchUsers() {
      let newData = [];
      newData = this.users.filter(
        (item) =>
          item.fullname.toLowerCase().includes(this.usersKey) ||
          item.fullname.toUpperCase().includes(this.usersKey) ||
          item.fullname.includes(this.usersKey)
      );
      this.filteredUsers = newData;
    },

    ...mapActions([
      "fetchallDevices",
      "getUsers",
      "createReport",
      "updateReport",
      "getReportTimezones",
    ]),
    moment: function (time) {
      return moment(time, "HH").format("HH:mm");
    },
    handleDeviceFocus() {
      this.showDevices = true;
    },
    handleHideDevices() {
      this.showDevices = false;
    },
    handleUserFocus() {
      this.showUsers = true;
    },
    handleHideUsers() {
      this.showUsers = false;
    },
    submitForm() {
      if (this.device.length < 1)
        return (this.erroNotification = this.$t("sel_one_dev"));
      this.isLoading = true;
      const getInterval = () => {
        let period = {};
        if (this.period === "weekly") {
          period = this.weekly;
        } else if (this.period === "monthly") {
          period = this.monthly;
        } else if (this.period === "daily") {
          period = this.daily;
        }
        return period;
      };

      const data = {
        title: this.title,
        devices: this.device,
        users: this.selectedEmailList,
        period: this.period,
        // from: getInterval().fromDay,
        // to: getInterval().toDay,
        // start: moment(`${getInterval().fromTime} + ${getInterval().fromAmPm}`, [
        //   "h:mm A",
        // ]).format("HH:mm"),
        // end: moment(`${getInterval().toTime} + ${getInterval().toAmPm}`, [
        //   "h:mm A",
        // ]).format("HH:mm"),
        // start: `${getInterval().fromTime}`,
        // end: `${getInterval().toTime}`,

        from: {
          day: getInterval().fromDay,
          time: getInterval().fromTime,
        },
        to: {
          day: getInterval().toDay,
          time: getInterval().toTime,
        },
        timeZone: this.timezone,
        format: this.format,
      };
      if (this.period === "daily") {
        delete data.from.day;
        delete data.to.day;
      }
      if (Object.keys(this.report).length > 0) {
        this.updateReport({ id: this.report.id, value: data })
          .then((res) => {
            this.isLoading = false;
            this.$emit("close_report_edit", "edit");
          })
          .catch((error) => {
            this.isLoading = false;
            this.$emit("close_report_edit");
            if (error.response) {
              //console.log(error.response.data.message);
            }
          });
      } else {
        this.createReport(data)
          .then((res) => {
            this.isLoading = false;
            this.$emit("close_report_edit");
            this.showSuccessPopup = true;
          })
          .catch((error) => {
            this.isLoading = false;
            this.$emit("close_report_edit");
            if (error.response) {
              //console.log(error.response.data.message);
            }
          });
      }
    },
    opendrop() {
      this.openDrop = !this.openDrop;
    },
    selectedEmails(e) {
      this.selectedEmailList = e;
    },
    closeDropdown() {
      this.openDrop = false;
    },
    selectAll() {
      this.all = true;
      this.devices.forEach((item) => {
        if (this.device.includes(item.id)) {
          return;
        } else this.device = [...this.device, item.id];
      });
    },
    deSelectAll() {
      this.all = false;
      this.device = [];
      const test = document.getElementsByName("selected-device");
      test.forEach((item) => {
        if (item.checked) {
          item.checked = false;
        }
      });
    },
    selectAllUsers() {
      this.all = true;
      // this.selectedEmailList.forEach((item) => {
      //   if (this.device.includes(item.imei)) {
      //     return;
      //   } else this.device = [...this.device, item.imei];
      // });
      this.selectedEmailList = this.users.map(({ id }) => id);
    },
    deSelectAllUsers() {
      this.all = false;
      this.selectedEmailList = [];
      const test = document.getElementsByName("selected-users");
      test.forEach((item) => (item.checked = false));
      // test.forEach((item) => {
      //   if (item.checked) {
      //     item.checked = false;
      //   }
      // });
    },
    cancel() {
      this.$emit("close_report_edit");
    },

    selectCheck(e) {
      if (this.device.includes(e)) {
        return true;
      } else return false;
    },
    selectCheckUser(e) {
      if (this.selectedEmailList.includes(e)) {
        return true;
      } else return false;
    },
    onDeviceSelect(e) {
      if ([...this.device].includes(e)) {
        const index = this.device.indexOf(e);
        if (index > -1) {
          this.device.splice(index, 1);
        }
      } else this.device = [...this.device, e];
    },
    onUserSelect(e) {
      if ([...this.selectedEmailList].includes(e)) {
        const index = this.selectedEmailList.indexOf(e);
        if (index > -1) {
          this.selectedEmailList.splice(index, 1);
        }
      } else this.selectedEmailList = [...this.selectedEmailList, e];
    },
    onFormatSelect(value) {
      if ([...this.format].includes(value)) {
        const index = this.format.indexOf(value);
        if (index > -1) {
          this.format.splice(index, 1);
        }
      } else {
        this.format = [...this.format, value];
      }
    },
  },
  mounted() {
    this.getUsers().then(() => {
      this.filteredUsers = this.users;
    });
    this.fetchallDevices().then(() => {
      this.filteredDevices = this.devices;
    });

    if (Object.keys(this.report).length > 0) {
      this.btnText = "Save Report";
      this.period = this.report.period;
      // Handle format as either string (legacy) or array (new)
      if (this.report.format) {
        this.format = Array.isArray(this.report.format)
          ? [...this.report.format]
          : [this.report.format];
      } else {
        this.format = ["pdf"];
      }
      this.device = [...this.report.devices];
      this.selectedEmailList = this.report.users;
      this.title = this.report.title;
      this.timezone = this.report.timeZone;
      switch (this.report.period) {
        case "weekly":
          this.weekly.fromDay = this.report.from.day;
          // this.weekly.fromTime = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.weekly.fromAmPm = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.weekly.fromTime = this.report.from.time;
          this.weekly.toDay = this.report.to.day;
          // this.weekly.toTime = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.weekly.toAmPm = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.weekly.toTime = this.report.to.time;
          break;
        case "monthly":
          this.monthly.fromDay = this.report.from.day;
          // this.monthly.fromTime = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.monthly.fromAmPm = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.monthly.fromTime = this.report.from.time;
          this.monthly.toDay = this.report.to.day;
          // this.monthly.toTime = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.monthly.toAmPm = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.monthly.toTime = this.report.to.time;
          break;
        case "daily":
          // this.daily.fromTime = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.daily.fromAmPm = moment(
          //   this.report.from.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.daily.fromTime = this.report.from.time;
          // this.daily.toTime = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("hh:mm");
          // this.daily.toAmPm = moment(
          //   this.report.to.time.toString(),
          //   "H:mm"
          // ).format("a");
          this.daily.toTime = this.report.to.time;
          break;
      }
    }
  },
  computed: {
    ...mapGetters(["devices", "users", "timezoneLoading", "reportTimezones"]),
    isDisabled() {
      return this.selectedEmailList.length === 0 || this.device.length === 0;
    },
    isSelectAll() {
      return this.device.length === this.filteredDevices.length;
    },
    isSelectAllUser() {
      return this.selectedEmailList.length === this.users.length;
    },
  },
  watch: {
    device: {
      handler: function () {
        if (this.device.length > 0) this.erroNotification = "";
      },
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  created() {
    this.getReportTimezones();
  },
};
</script>

<style scoped>
select {
  background: rgba(236, 236, 236, 0.55);
}
input {
  background: rgba(236, 236, 236, 0.55);
}
.top-select {
  padding-right: 1rem;
  background-color: #f9fafb;
}
.top-select span {
  padding: 0.1rem 2rem;
}
.device-select {
  /* border: solid 1px lightgrey; */
}
.device-select::placeholder {
  /* border: solid 1px lightgrey; */
  color: #b7c3cd;
  font-size: 14px;
}
.top-select i {
  align-self: center;
  margin-left: auto;
}
.check-devices input {
  margin-top: auto;
  margin-bottom: auto;
}
.devices {
  max-height: 10.3rem;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  padding: 12px 16px 16px 16px;

  position: absolute;
  width: 100%;
  z-index: 300;
}
.title-format {
  display: flex;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns of equal width */
  grid-template-rows: repeat(2, 1fr); /* 2 rows of equal height */
  gap: 16px; /* Gap between grid items (adjust as needed) */
}
.active-select {
  background: rgba(33, 62, 122, 0.15);
  border-radius: 8px;
  color: #213e7a;
}
.form {
  padding: 20px 45px;
}
.form .form-group {
  height: 50px;
}
.format-options {
  display: flex;
  padding-inline: 10px;
  gap: 10px;
}
.format-options .check-devices {
  margin-bottom: 0.5rem;
}
.check-devices label {
  margin-left: 5px;
}
@media (max-width: 576px) {
  .title-format,
  .grid-container {
    display: block;
  }
  .form {
    padding: unset;
  }
}
</style>

<i18n>
{
	"en": {
		"add_user": "Add user Staff",
		"daily": "Daily",
		"desel_all": "Deselect all ",
		"ent_rep_title": "Enter a Report title",
		"fri": "Friday",
		"from": "From",
		"gen_": "Generate",
		"mond": "Monday",
		"monthly": "Monthly",
		"no_dev_found": "No Device Found",
		"period": "Period",
		"sat": "Saturday",
		"sch_auto": "Schedule your report reading automatically",
		"sel": "Select",
		"sel_all": "Select all",
		"sel_one_dev": "Select at least one device",
		"sun": "Sunday",
		"thur": "Thursday",
		"title": "Title",
		"to": "To",
		"tue": "Tuesday",
		"wed": "Wednesday",
		"weekly": "Weekly"
	},
	"es": {
		"add_user": "Agregar personal de usuario",
		"daily": "diario",
		"desel_all": "Deseleccionar todo",
		"ent_rep_title": "Ingrese un título de informe",
		"fri": "viernes",
		"from": "Desde",
		"gen_": "Generar",
		"mond": "lunes",
		"monthly": "Mensual",
		"no_dev_found": "Ningún dispositivo encontrado",
		"period": "período",
		"sat": "sábado",
		"sch_auto": "Programe la lectura de su informe automáticamente",
		"sel": "Seleccionar",
		"sel_all": "Seleccionar todo",
		"sel_one_dev": "Seleccione al menos un dispositivo",
		"sun": "domingo",
		"thur": "jueves",
		"title": "Título",
		"to": "a",
		"tue": "martes",
		"wed": "miércoles",
		"weekly": "Semanal"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"daily": "du quotidien",
		"desel_all": "Tout déselectionner",
		"ent_rep_title": "Saisissez un titre de rapport",
		"fri": "Vendredi",
		"from": "De",
		"gen_": "produire",
		"mond": "Lundi",
		"monthly": "Mensuel",
		"no_dev_found": "Aucun appareil trouvé",
		"period": "Période",
		"sat": "samedi",
		"sch_auto": "Programmez la lecture de votre rapport automatiquement",
		"sel": "sélectionner",
		"sel_all": "Tout sélectionner",
		"sel_one_dev": "Sélectionnez au moins un appareil",
		"sun": "dimanche",
		"thur": "JEUDI",
		"title": "Titre",
		"to": "à",
		"tue": "Mardi",
		"wed": "Mercredi",
		"weekly": "Hebdomadaire"
	},
	"sw": {
		"add_user": "Ongeza Wafanyikazi wa watumiaji",
		"daily": "Kila siku",
		"desel_all": "Usichague zote",
		"ent_rep_title": "Weka kichwa cha Ripoti",
		"fri": "Ijumaa",
		"from": "Kutoka",
		"gen_": "Tengeneza",
		"mond": "Jumatatu",
		"monthly": "kila mwezi",
		"no_dev_found": "Hakuna Kifaa Kilichopatikana",
		"period": "Kipindi",
		"sat": "Jumamosi",
		"sch_auto": "Ratibu usomaji wa ripoti yako kiotomatiki",
		"sel": "Chagua",
		"sel_all": "Chagua Zote",
		"sel_one_dev": "Chagua angalau kifaa kimoja",
		"sun": "Jumapili",
		"thur": "Alhamisi",
		"title": "Kichwa",
		"to": "Kwa",
		"tue": "Jumanne",
		"wed": "Jumatano",
		"weekly": "Kila wiki"
	}
}
</i18n>
